import { read, utils, WorkBook } from "xlsx";

const ENCRYPTED_FILE_KEYWORDS = ["ECMA-376", "Encrypted", "Encryption", "encrypt", "password"];

const CONFIDENTIAL_FILE_ERROR_MESSAGE =
  "This document is labeled Confidential, which is not supported,Please change the sensitivity label to Internal or General, then upload the file again.";

const isEncryptedFileError = (message: string): boolean =>
  ENCRYPTED_FILE_KEYWORDS.some((keyword) => message.includes(keyword));

export const getBatchFields = async (file: File, domainData: any) => {
  try {
    const buffer = await file.arrayBuffer();
    const wb: WorkBook = read(buffer);

    // Find sheet with "Batch JE" in the name
    const batchJESheetName = wb.SheetNames.find((sheetName) => sheetName.toLocaleLowerCase().includes("batch je"));

    if (!batchJESheetName) {
      throw new Error("No sheet containing 'Batch JE' found in the workbook");
    }

    const ws = wb.Sheets[batchJESheetName];
    const headerFieldsArray: any[] = utils.sheet_to_json(ws, { header: 1, defval: "", range: "A3:H11" });
    const batchName = headerFieldsArray[1][1];
    const description = headerFieldsArray[2][1];
    const batchDescription = description.substring(0, 25);
    const purpose = headerFieldsArray[3][1];
    const batchPurpose = purpose.substring(0, 250);
    const reason = headerFieldsArray[0][3];
    const reasonCode = domainData.find((x) => x.jeReason === reason);
    const batchReasonCode: string = reasonCode ? reasonCode.code : "";
    return {
      batchName,
      batchDescription,
      batchPurpose,
      batchReasonCode
    };
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : String(error);
    console.error("File read error:", errorMessage);
    if (isEncryptedFileError(errorMessage)) {
      alert(CONFIDENTIAL_FILE_ERROR_MESSAGE);
      return;
    }
    throw new Error("Error occurred during file processing :" + errorMessage);
  }
};
